/*
 * @version: v 1.0.0
 * @Github: https://github.com/GitHubGanKai
 * @Author: GitHubGanKai
 * @Date: 2020-12-27 20:10:38
 * @LastEditors: gankai
 * @LastEditTime: 2021-01-02 13:39:04
 * @FilePath: /refactor-with-vue3/src/main.js
 */
import { createApp } from 'vue'
import Vant from 'vant'
import 'lib-flexible/flexible'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "@/plugins/axios";
import icons from '@/icons' // icon
import components from '@/components' // icon
import 'vant/lib/index.css' // 全局引入样式
import './mock/mock'
import eventBus from './utils/eventBus'
import { registerPlugins } from './utils/util'
import VConsole from 'vconsole';
import wx from 'weixin-js-sdk'
import VueWechatTitle from 'vue-wechat-title'
document.querySelector("body").setAttribute("style", "overflow: auto !important;")

const isPc = () => {
    const userAgentInfo = navigator.userAgent;
    const Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

//如果不是生产环境并且不是pc设备那么就显示调试
if (process.env.NODE_ENV != "production" && !isPc()) {
    const vConsole = new VConsole();
}

const plugins = [Vant, store, router, axios, icons, components, eventBus, wx, VueWechatTitle]
const app = createApp(App);
app.use(registerPlugins(plugins))
app.mount("#app")
